import { getDefaultStyleParams } from './viewerScript/getDefaultStyleParams';
export function getStyleParamsWithDefaultsFunc(_a) {
    var styleParams = _a.style.styleParams, dimensions = _a.dimensions;
    ['galleryColumns', 'galleryRows'].forEach(function (key) {
        if (styleParams.numbers[key] !== undefined) {
            styleParams.numbers[key] = Math.round(styleParams.numbers[key]);
        }
    });
    var _b = styleParams, showAlternativeImage = _b.booleans.showAlternativeImage, galleryColumns = _b.numbers.galleryColumns;
    return { defaults: getDefaultStyleParams(showAlternativeImage, galleryColumns, dimensions), overrides: styleParams };
}
//# sourceMappingURL=getStyleParamsWithDefaultsFunc.js.map